import React from 'react';
import { Button, ButtonProps, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CommonButtonProps extends ButtonProps {
    translationKey: string;
}

const CommonButton: React.FC<CommonButtonProps> = ({
    translationKey,
    color = 'primary',
    fullWidth = true,
    type = 'button',
    ...props
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Button
            type={type}
            color={color}
            fullWidth={fullWidth}
            sx={{
                height: '52px',
                borderRadius: '16px',
                fontFamily: 'Nunito Sans Bold',
                // fontWeight: 700,
                fontSize: '14px',
                bgcolor: theme.palette.primary.main,
                '&:hover': {
                    bgcolor: theme.palette.primary.main,
                },
                color: theme.palette.secondary.main,
                ...props.sx,
            }}
            {...props}
        >
            {t(translationKey)}
        </Button>
    );
};

export default CommonButton;